export const MIN_HEIGHT_METRIC = 0.74
export const MAX_HEIGHT_METRIC = 2.25
